/* eslint-disable unicorn/consistent-function-scoping */
/* eslint-disable arrow-body-style */
/* eslint-disable react/function-component-definition */
import { Paper } from "@material-ui/core";
import { NoteAlt } from "@mui/icons-material";
import { Dialog, DialogContent, DialogContentText } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { ApiService } from "../../constants/ApiService";
import { HttpService } from "../../constants/HTTPService";
import { ITrRequest } from "../../interfaces/ITrRequest";
import { selectNewProfile } from "../../store/newProfile/selector";

const DialogQuestionnaire = ({ open }: { open: boolean }) => {
  const [isOpen, setIsOpen] = useState(open);
  const [listRequestFinished, setListRequestFinished] = useState<ITrRequest[]>(
    []
  );
  const profile = useSelector(selectNewProfile);

  useEffect(() => {
    const firstLoad = async () => {
      const data = HttpService.post(
        ApiService.questionnaire.getRequestFinished,
        JSON.stringify({
          BinusianID: profile.BinusianId,
        })
      );
      const dataAPI = (await data).data;
      if (dataAPI.data.length > 0) {
        setListRequestFinished(dataAPI.data);
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }
    };
    firstLoad();
  }, []);

  const handleClose = () => {
    setIsOpen(true);
  };

  const columnsToUse: any = [
    {
      field: "number",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderHeader: () => <b>No</b>,
      sortable: false,
    },
    {
      field: "requestNumber",
      headerAlign: "center",
      align: "center",
      width: 150,
      renderHeader: () => <b>Request Status</b>,
      sortable: false,
    },
    {
      field: "requestDate",
      headerAlign: "center",
      align: "center",
      width: 150,
      renderHeader: () => <b>Request No.</b>,
      sortable: false,
    },
    {
      width: 100,
      renderHeader: () => <b>Action</b>,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params): any => (
        <Link
          to={`/questionnaire/${params.row.requestID}`}
          style={{ width: "30px" }}
        >
          <NoteAlt className="noteAction" />
        </Link>
      ),
    },
  ];
  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <Paper
        style={{
          padding: "25px",
        }}
      >
        <DialogContent>
          <DialogContentText sx={{ textAlign: "center" }}>
            <b>
              Mohon Bapak/Ibu dapat melengkapi kuisioner dibawah sebelum
              mengajukan permintaan dokumen baru. Terima kasih
            </b>
            <p>
              Please complete the questionnaire below before submitting new form
              request. Thank you
            </p>
          </DialogContentText>
        </DialogContent>
        <div style={{ width: "100%", backgroundColor: "white" }}>
          <DataGrid
            rows={
              listRequestFinished.map((item, idx) => ({
                number: idx + 1,
                ...item,
              })) || []
            }
            columns={columnsToUse}
            getRowId={(row) => row.requestID}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 },
              },
            }}
            pageSizeOptions={[10]}
            autoHeight
            getRowHeight={() => "auto"}
            disableRowSelectionOnClick
            disableColumnMenu
          />
        </div>
      </Paper>
    </Dialog>
  );
};

export default DialogQuestionnaire;
